export enum SessionDataEnum {
  AdmOrRoot = 'admOrRoot',
  ApiToken = 'token',
  ApiUrl = 'apiUrl',
  ApiUrl360 = 'apiUrl360',
  SocketIOUrl = 'socketIOUrl',
  BuiltInMode = 'builtInMode',
  HideAppBar = 'hideAppBar',
  ClientType = 'clientType',
  OrderCode = 'orderCode',
  WebsocketCallCenter = 'websocketCallCenter',
  ExtensionCallCenter = 'extensionCallCenter',
  IdCallCenter = 'idCallCenter',
  ShowStatusCallCenterHeader = 'showStatusCallCenterHeader',
  PartnerApiCallCenter = 'partnerApiCallCenter',
  PartnerCodeCallCenter = 'partnerCodeCallCenter',
  ShowNotificationCallCenter = 'showNotificationCallCenter',
  UnitIdentifierCallCenter = 'unitIdentifierCallCenter',
  CallCenterAgentId = 'callCenterAgentId',
  GeoTabOpener = 'geoTabOpener',
}
